"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasetNameSchema = void 0;
const zod_1 = require("../../utils/zod");
const validation_1 = require("../folders/validation");
/**
 * Dataset name validation schema for API, tRPC and client
 */
exports.DatasetNameSchema = (0, validation_1.withFolderPathValidation)(zod_1.StringNoHTMLNonEmpty);
